import React, { useState } from "react";

const LoginFrame = (props) => {
  const { children } = props;
  return (
    <div>
      {/* BEGIN LOGO */}
      <div className="logo">
        <div className="msa-vanco-logo">
          <svg style={{ height: "inherit" }}>
            <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0"
            y="0"
            enableBackground="new 0 0 344.7 144"
            version="1.1"
            viewBox="0 0 344.7 144"
            xmlSpace="preserve"
          >
            <defs>
                  <style
                    dangerouslySetInnerHTML={{
                      __html: ".st0{fill:#312852;}.st1{clip-path:url(#SVGID_2_);fill:#312852;}.st2{clip-path:url(#SVGID_2_);fill:#FFFFFF;}",
                    }}
                  />
            </defs>
            <path
              d="M188.2 53L188.2 70.5 213.3 70.5 213.3 76.6 188.2 76.6 188.2 96.8 181.1 96.8 181.1 46.8 216.3 46.8 216.3 53z"
              className="st0"
            ></path>
            <defs>
              <path id="SVGID_1_" d="M0 0H344.7V144H0z"></path>
            </defs>
            <clipPath>
              <use overflow="visible" xlinkHref="#SVGID_1_"></use>
            </clipPath>
            <path
              d="M218.8 77.9c0-11.3 8.3-19.3 19.7-19.3 11.3 0 19.6 8 19.6 19.3s-8.3 19.3-19.6 19.3c-11.4 0-19.7-8-19.7-19.3m32.4 0c0-8.1-5.4-13.3-12.7-13.3-7.3 0-12.8 5.2-12.8 13.3s5.5 13.3 12.8 13.3c7.2 0 12.7-5.3 12.7-13.3M262.2 77.9c0-11.3 8.4-19.3 19.7-19.3 11.3 0 19.6 8 19.6 19.3s-8.3 19.3-19.6 19.3c-11.4 0-19.7-8-19.7-19.3m32.4 0c0-8.1-5.4-13.3-12.7-13.3-7.3 0-12.8 5.2-12.8 13.3s5.5 13.3 12.8 13.3c7.2 0 12.7-5.3 12.7-13.3M344.7 43.8v53h-6.6v-6c-3.1 4.3-7.9 6.4-13.5 6.4-11.1 0-19.1-7.8-19.1-19.3 0-11.6 8.1-19.3 19.1-19.3 5.4 0 10.1 2 13.2 6.1V43.8h6.9zm-6.8 34.1c0-8.1-5.5-13.3-12.7-13.3-7.3 0-12.8 5.2-12.8 13.3s5.5 13.3 12.8 13.3c7.3 0 12.7-5.3 12.7-13.3"
              className="st1"
            ></path>
            <path
              d="M141.4 72c0 38.3-31 69.4-69.4 69.4-38.3 0-69.4-31.1-69.4-69.4S33.7 2.6 72 2.6c38.3 0 69.4 31.1 69.4 69.4"
              className="st2"
            ></path>
            <path
              d="M72 89.6l-6.2-11.1-19-34.2c-1-1.7-2.8-2.7-4.7-2.7H26.6s41.2 73.8 41.3 73.9c.9 1.4 2.4 2.3 4.1 2.3 1.7 0 3.2-.9 4.1-2.3.1-.1.1-.2.2-.3 0 0 2.3-4 5-8.8L72 89.6zM75.7 83.1l2.5-4.7 19-34.2c1-1.7 2.8-2.7 4.7-2.7h15.5s-17.8 31.9-30 53.7c-1.1 1.9-1.4 2.6-2.4 4.4l-9.3-16.5z"
              className="st1"
            ></path>
            <path
              d="M72 144c-39.7 0-72-32.3-72-72S32.3 0 72 0s72 32.3 72 72-32.3 72-72 72M72 4.9C35 4.9 4.9 35 4.9 72S35 139.1 72 139.1 139.1 109 139.1 72 109 4.9 72 4.9"
              className="st1"
            ></path>
            </svg>
          </svg>
        </div>
      </div>
      {/* END LOGO */}
      <div className="portlet-title">
        <div className="caption text-center">
          <strong>Point of Sale Admin</strong>
        </div>
      </div>
      {/* BEGIN LOGIN */}
      <div className="content">
        {/* BEGIN LOGIN FORM */}
        {children}
        {/* END LOGIN FORM */}
      </div>
      {/* END LOGIN */}
      {/* BEGIN COPYRIGHT */}
      <div className="copyright">
        {new Date().getFullYear()} © Food Service Solutions, Inc.
      </div>
    </div>
  );
};

export default LoginFrame;
